import React from "react";

const MemeHolder = (props) => {
  return (
    <div id="memeDisplay">
      <h4 className="topText">{props.topText}</h4>
      <img
        src={props.url}
        alt={props.name}
        className="displayImage"
        style={{ width: "100%" }}
      />
      <h4 className="bottomText">{props.bottomText}</h4>
    </div>
  );
};

export default MemeHolder;
